import SubcategorySelector from './SubcategorySelector.jsx';

export default SubcategorySelector;


// WEBPACK FOOTER //
// ./src/components/SubcategorySelector/index.jsx